import { FieldValue, FieldWithValue, FormValuesType } from 'src/UI/dynamicUI/types';
import { FormErrors } from '@mantine/form';

export function validateContributionEndDate(
  contributionKey: string,
  value: FieldWithValue | FieldWithValue[] | FieldValue | FieldValue[],
  values: FormValuesType,
  path: string,
) {
  if (!value) {
    return null;
  }
  const match = path.match(new RegExp(`^${contributionKey}\\.(\\d+)\\.end_date$`));
  if (match) {
    const index = Number(match[1]);
    const startDate = (values[contributionKey] as { start_date: Date }[])[index].start_date;

    if (!startDate) {
      return 'Cannot have an end date without a start date';
    }

    if (Date.parse(value.toString()) < Date.parse(startDate.toString())) {
      return 'End date cannot be before start date';
    }
  }
  return null;
}

export function scrollToElementWithError(errors: FormErrors) {
  const fieldName = Object.keys(errors)[0];
  const element = document.getElementById(fieldName);
  element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
